export const getStorageItem = (id: string) => window.localStorage.getItem(id);

export const setStorageItem = (id: string, value: string | boolean) =>
  window.localStorage.setItem(id, String(value));
